module.exports = {
  bouquet: {
    standard: 100,
    medium: 150,
    large: 180
  },
  urgent_delivery: 5,
  card: 3,
  life_zone: {
    zone_1: 20,
    zone_2: 25,
    zone_3: 29,
    zone_4: 35,
    zone_5: 43
  },
  delivery: {
    specific_time: 15,
    rush_hour: 10
  },
  pickup_time: 0
}
